<template>
    <div>
        <v-form ref="changeEmail" lazy-validation v-model="formValid" autocomplete="off" v-if="!isShowFormCode">
            <p class="text-h5">Изменение email</p>
            <v-text-field
                autocomplete="off"
                label="Новый email"
                placeholder="Новый email"
                v-model="email"
                type="text"
                :rules="[
                    v => !!v || 'Поле обязательно для заполнения',
                    v => /.+@.+/.test(v) || 'Укажите дейсвительный email'
                ]"
                class="mb-4"
                outlined
                dense
                persistent-hint>
            </v-text-field>
            <v-text-field
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                autocomplete="off"
                label="Текущий пароль"
                placeholder="Текущий пароль"
                v-model="password"
                :rules="[v => !!v || 'Поле обязательно для заполнения',]"
                class="mb-4"
                outlined
                dense
                persistent-hint>
            </v-text-field>
            <div class="d-flex justify-center">
                <v-btn
                    color="primary"
                    @click="onSendMail"
                >
                    Отправить запрос
                </v-btn>
                <v-spacer></v-spacer>
            </div>

        </v-form>
        <v-form ref="changeEmailCode" lazy-validation v-model="confirmFormValid" autocomplete="off" v-else>
            <p class="text-h5">Изменение email</p>
            <v-text-field
                autocomplete="off"
                label="Код подтверждения"
                placeholder="Код подтверждения"
                v-model="code"
                type="text"
                :rules="[
                    v => !!v || 'Поле обязательно для заполнения'
                ]"
                class="mb-4"
                outlined
                dense
                persistent-hint>
            </v-text-field>
            <div class="d-flex justify-center">
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    @click="onSendCode"
                >
                    Изменить email
                </v-btn>
            </div>
        </v-form>
        <v-overlay :value="isFetching" :absolute="true">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import * as apiUser from '@/api/user';
import { mapGetters, mapActions } from 'vuex';
import {validateErrToString} from '@/mixins/helper';
export default {
    name: 'ChangeEmail',
    components:{
        
    },
    data () {
        return {
            showPassword: false,
            confirmFormValid: false,
            isShowFormCode: false,
            isFetching: false,
            formValid: true,
            password: '',
            email: '',
            code: ''
        }
    },
      methods: {
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR']),
        ...mapActions('user', ['UPDATE_USER']),
        async onSendMail(){
            this.isFetching = true;
            try{
                let response = await apiUser.changeEmailSend(this.USER_ID, {
                    email: this.email,
                    password: this.password,
                });
                this.SHOW_SUCCESS(response.data.message);
                this.isShowFormCode = true;
            }catch(err){
              console.log(err);
              let message = 'Ошибка запроса';
              if(undefined !== err.response.data.error){
                  message = err.response.data.error
              }else if(undefined !== err.response.data.errors && err.response.status == 422){
                  message = validateErrToString(err.response.data.errors);
              }
              this.SHOW_ERROR(message);
            }finally{
                this.isFetching = false;
            }
        },
        async onSendCode(){
            this.isFetching = true;
            try{
                let response = await apiUser.changeEmailConfirm(this.USER_ID, {
                    code: this.code,
                });
                this.SHOW_SUCCESS(response.data.message);
                this.UPDATE_USER();
                this.isShowFormCode = false;
                this.code = '';
            }catch(err){
              console.log(err);
              let message = 'Ошибка запроса';
              if(undefined !== err.response.data.error){
                  message = err.response.data.error
              }else if(undefined !== err.response.data.errors && err.response.status == 422){
                  message = validateErrToString(err.response.data.errors);
              }
              this.SHOW_ERROR(message);
            }finally{
                this.isFetching = false;
            }
        },
    },
    computed:{
        ...mapGetters('user', ['USER_ID'])
    },
}
</script>

<style src="./Edit.scss" lang="scss"></style>